import * as types from '../mutation-types'

//建议对于getters,actions都加上模块名
// initial state
const state = {
	firstLoad: true,//是否为第一加载
	tokenId: '',
	accessToken: {}, //accessToken
	context: {}, //上下文
	menuMap: {}, //菜单MAP结构
	menuUrlMap: {},
	topMenuActiveIndex: -1, //顶部菜单激活索引
	preTopMenuActiveIndex: -1, //上次被激活的顶部索引
	currentActivePath: null, //当前激活的路径
	currentActiveMenuPath: null, //当前激活的菜单路径
	currentActiveMenuList: [], //当前激活的菜单信息
	currentActiveTopPath: 0, //当前激活顶部菜单
	crumbs: [] //导航信息
}

// getters
const getters = {
	framework_isFirstLoad: state => state.firstLoad,
	auth_tokenId: state => state.tokenId,
	auth_accessToken: state => state.accessToken, //accessToken
	auth_user: state => state.context.userBO,
	auth_roles: state => state.context.roleList,
	auth_perms: function(state) {
		console.log('auth perms...');
		let pmsList = state.context.permissionList;
		let pmsMap = {};
		let pmsListLength = pmsList.length;
		for (let i = 0; i < pmsListLength; i++) {
			let pcode = pmsList[i];
			// let pcode = pvalue.code;
			pmsMap[pcode] = pcode;
		}
		return pmsMap;
	},
	auth_version: state => state.context.version,
	auth_projectName: state => state.context.projectName,
	auth_menuTree: state => state.context.menuTree,
	auth_menuMap: state => state.menuMap,
	auth_exts: state => state.context.exts,
	framework_crumbs: state => state.crumbs, //导航信息
	currentActivePath: state => state.currentActivePath,
	currentActiveMenuPath: state => state.currentActiveMenuPath,
	currentActiveMenuList: function(state) {
		let currentActiveTopPath = state.currentActiveTopPath;
		let activeIndex = currentActiveTopPath;
		let menuList_ = [];
		let menuTree_ = state.context.menuTree;
		let menus_ = menuTree_.children;
		if(menus_ && menus_.length > 0) {
				let curMenu_ = menus_[activeIndex];
				if(1 == curMenu_.tree.wType) {
						menuList_ =  curMenu_.children;
				} else {
						menuList_ =  menus_;
				}
		}
		return menuList_;
	},
	currentActiveTopPath: state => state.currentActiveTopPath
}

// actions
const actions = {
	//绑定缓存
	authBindAccessToken({
		commit,
		state
	}, tokenId) {
		commit(types.AUTH_BIND_ACCESSTOKEN, tokenId);
	},
	//刷新缓存
	authFlushAccessToken({
		commit,
		state
	}) {
		commit(types.AUTH_FLUSH_ACCESSTOKEN);
	},
	//登出
	authLogout({
		commit,
		state
	}) {
		commit(types.AUTH_LOGOUT);
	},
	//登录保存
	authLogin({
		commit,
		state
	}, context_) {
		commit(types.AUTH_LOGIN, context_);
	},
	//菜单切换
	authMenuToggle({
		commit,
		state
	}, params_) {
		commit(types.AUTH_MENU_TOGGLE, params_);
	},
	//菜单点击
	authMenuItemClick({
		commit,
		state
	}, params_) {
		commit(types.AUTH_MENU_ITEMCLICK, params_);
	},
	//刷新当前的菜单
	authFlushMenu({
		commit,
		state
	}, params_) {
		commit(types.AUTH_FLUSH_MENU, params_);
	},
	//点击顶部菜单索引
	frameworkTopMenuActiveIndex({
		commit,
		state
	}, params_) {
		commit(types.FRAMEWORK_TOPMENU_ACTIVE, params_);
	},
	//最后的菜单点击导航提示
	frameworkLastCrumbActive({
		commit,
		state
	}, params_) {
		commit(types.FRAMEWORK_LAST_ACTIVE, params_);
	} 
}

//构建菜单树
function buildMenuList(state, activeIndex) {
	let menuTree_ = state.context.menuTree;
	let menuList_ = [];
	if (menuTree_) {
		let menus_ = menuTree_.children;
		let curMenu_ = menus_[activeIndex];
		if (1 == curMenu_.tree.wType) {
			menuList_ = curMenu_.children;
		} else {
			menuList_ = menus_;
		}
	}
	return menuList_;
}

//构建菜单结构MAP
function buildMenuMap(state, context_) {
	let menuTree_ = state.context.menuTree;
	if (menuTree_) {
		buildMenuMap1(menuTree_, state.menuMap, state.menuUrlMap);
	}
}

function buildMenuMap1(menuTree_, menuMap_, menuUrlMap_) {
	let menus_ = menuTree_.children;
	if (menus_ && menus_.length > 0) {
		for (let i = 0; i < menus_.length; i++) {
			let menu_ = menus_[i];
			buildMenuMap1(menu_, menuMap_, menuUrlMap_);
		}
	} else if (menuTree_.tree) {
		let url_ = menuTree_.tree.url;
		let indexPath_ = menuTree_.indexPath;
		menuMap_[indexPath_] = menuTree_;
		menuUrlMap_['/' + url_] = menuTree_;
	}
}


/**
 * 激活当前的导航
 * @param  {[type]} state [description]
 * @param  {[type]}       [description]
 * @return {[type]}       [description]
 */
function activeCrub(state, indexPath_) {
	let menuTree_ = state.context.menuTree;
	// console.log(currItem_);
	// console.log(menuTree_);
	state.crumbs = [];

	let indexs_ = indexPath_;
	let curMenus_ = menuTree_.children;
	for (let i in indexs_) {
		let index_ = indexs_[i];
		// console.log('curIndex:' + index_);
		if (!curMenus_) {
			continue;
		}
		let curMenu_ = curMenus_[index_];
		curMenus_ = curMenu_.children;
		// console.log('curMenu:' + curMenu_.label);
		state.crumbs.push({
			name: curMenu_.label
		});
	}
}

function buildVersions(context_) {
	let versionInfo = localStorage.getItem('wsplus_auth_version');
	let exts = context_.exts;
	context_.exts.needTip = false;
	if(!versionInfo) {
		//不存在,第一次则需要进行提示
		let data = {
			version: exts.version,
			time: exts.time
		};
		localStorage.setItem('wsplus_auth_version', JSON.stringify(data));
		context_.exts.needTip = true;
	} else {
		let data = JSON.parse(versionInfo);
		if(data.version != exts.version) {
			context_.exts.needTip = true;
		}
	}
}

// mutations
const mutations = {
	//绑定tokenId
	[types.AUTH_BIND_ACCESSTOKEN](state, tokenId) {
		state.tokenId = tokenId;
		//同时需要存储到sessionStorage
		localStorage.setItem('wsplus_auth_tokenId', tokenId);
	},
	[types.AUTH_FLUSH_ACCESSTOKEN](state) {
		//同时需要存储到sessionStorage
		let tokenId = localStorage.getItem('wsplus_auth_tokenId');
		state.tokenId = tokenId;
	},
	[types.AUTH_LOGOUT](state) {
		localStorage.removeItem('wsplus_auth_tokenId');
	},
	//登录
	[types.AUTH_LOGIN](state, context_) {
		console.log('auth login.....');
		state.context = context_;
		buildMenuMap(state, context_);
		// buildVersions(context_);
	},
	//菜单切换
	[types.AUTH_MENU_TOGGLE](state, params_) {
		let indexPath = params_.indexPath;
		state.currentActiveMenuPath = indexPath;
	},
	//菜单点击
	[types.AUTH_MENU_ITEMCLICK](state, params_) {
		state.currentActivePath = params_.indexPath;
		state.currentActiveMenuPath = params_.menuPath;
	},
	//刷新菜单
	[types.AUTH_FLUSH_MENU](state, params_) {
		state.firstLoad = false;
		let path = params_.path;
		let router = params_.router;
		if(path === '/') {
			state.currentActiveMenuPath = '0_0';
			state.currentActivePath = '0_0_0';
			state.currentActiveTopPath = 0;
			let menuMap = state.menuMap;
			let menu = menuMap['0_0_0'];
			router.push('/' + menu.tree.url);
		} else {
			let menuUrlMap = state.menuUrlMap;
			let menu = menuUrlMap[path];
			if(!menu) {
				if(!state.currentActiveTopPath) {
					state.currentActiveTopPath = 0;
				}
				return;
			}
			let indexPath = menu.indexPath;
			let indexs = indexPath.split('_');
			state.currentActivePath = indexPath;
			state.currentActiveMenuPath = indexs[0] + '_' + indexs[1];
			state.currentActiveTopPath = parseInt(indexs[0]);
		}
	},
	//激活索引
	[types.FRAMEWORK_TOPMENU_ACTIVE](state, params_) {
		let index_ = params_.index;
		let item_ = params_.item;
		let router = params_.router;
		
		state.currentActiveMenuPath = index_ + '_0';
		state.currentActivePath = index_ + '_0_0';
		state.currentActiveTopPath = index_;
		let menuMap = state.menuMap;
		let menu = menuMap[index_ + '_0_0'];
		router.push('/' + menu.tree.url);
	},
	//激活导航菜单索引
	[types.FRAMEWORK_LAST_ACTIVE](state, params_) {
		let currItem_ = params_.item;
		let indexPath_ = currItem_.indexPath;
		activeCrub(state, indexPath_.split('_'));
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/auth.js